/* istanbul ignore file */
import React from 'react';

// eslint-disable-next-line no-restricted-imports
import {Theme, ThemeOptions, ThemeProvider, createTheme} from '@veneer/core';

import {WolfTheme} from './types';
import {getWolfPalette, getWolfSpacings} from './utils';

const defaultTheme = createTheme({mode: 'light', density: 'standard', shape: 'round'});

const mergeThemes = (theme: Theme): WolfTheme => {
    return {
        ...theme,
        palette: getWolfPalette(theme.mode),
        spacings: getWolfSpacings(theme.density),
    };
};

const WolfThemeContext = React.createContext<WolfTheme>(mergeThemes(defaultTheme));

const WolfThemeProvider = ({
    children,
    ...themeOptions
}: {children: React.ReactNode} & Omit<ThemeOptions, 'customSystem'>): JSX.Element => {
    const theme = createTheme({...themeOptions});

    return (
        <ThemeProvider {...themeOptions}>
            <WolfThemeContext.Provider value={mergeThemes(theme)}>{children}</WolfThemeContext.Provider>
        </ThemeProvider>
    );
};

const useWolfTheme = (): WolfTheme => React.useContext(WolfThemeContext);

export {WolfThemeProvider, useWolfTheme};
